import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconExpandSimple2"><Path fillRule="evenodd" clipRule="evenodd" d="M5 12V5H12V6.5H6.5V12H5ZM12 17.5H17.5V12H19V19H12V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple2;
